export const SECTION_TEMPLATE_LIST = 'src/components/Scorecard/SectionTemplate/list/action/Section_Template_List';
export const getSectionTemplateList = (data) => {
    return {
        type: SECTION_TEMPLATE_LIST,
        data
    }
}

export const GET_SECTION_TEMPLATE_SUCCESSFULL = 'src/components/Scorecard/SectionTemplate/list/action/Section_Template_List_Successfull';
export const GET_SECTION_TEMPLATE_FAILURE = 'src/components/Scorecard/SectionTemplate/list/action/Section_Template_List_Failure';

export const getSectionTemplateListSuccess = (data) => {
    return {
        type: GET_SECTION_TEMPLATE_SUCCESSFULL,
        data
    }
}
export const getSectionTemplateListFail = (data) => {
    return {
        type: GET_SECTION_TEMPLATE_FAILURE,
        data
    }
}

export const DOWNLOAD_MASTER_DATA_KEY_TEMPLATE = 'src/components/Scorecard/SectionTemplate/list/action/Master_Data_Key_Template';
export const DOWNLOAD_MASTER_DATA_KEY_TEMPLATE_SUCCESSFULL = 'src/components/Scorecard/SectionTemplate/list/action/Master_Data_Key_Template_Successfull';
export const DOWNLOAD_MASTER_DATA_KEY_TEMPLATE_FAILURE = 'src/components/Scorecard/SectionTemplate/list/action/Master_Data_Key_Template_Failure';
export const downloadMasterDataKeyTemplate = (data) => {
    return {
        type: DOWNLOAD_MASTER_DATA_KEY_TEMPLATE,
        data
    }
}

export const downloadMasterDataKeyTemplateSuccess = (data) => {
    return {
        type: DOWNLOAD_MASTER_DATA_KEY_TEMPLATE_SUCCESSFULL,
        data
    }
}
export const downloadMasterDataKeyTemplateFail = (data) => {
    return {
        type: DOWNLOAD_MASTER_DATA_KEY_TEMPLATE_FAILURE,
        data
    }
}

export const UPLOAD_BULK_MASTER_DATA_KEY = 'src/components/Scorecard/SectionTemplate/list/action/Upload_Bulk_Master_Data_Key';
export const UPLOAD_BULK_MASTER_DATA_KEY_SUCCESSFULL = 'src/components/Scorecard/SectionTemplate/list/action/Upload_Bulk_Master_Data_KeySuccessfull';
export const UPLOAD_BULK_MASTER_DATA_KEY_FAILURE = 'src/components/Scorecard/SectionTemplate/list/action/Upload_Bulk_Master_Data_KeyFailure';
export const uploadBulkMasterDataKey = (data) => {
    return {
        type: UPLOAD_BULK_MASTER_DATA_KEY,
        data
    }
}

export const uploadBulkMasterDataKeySuccess = (data) => {
    return {
        type: UPLOAD_BULK_MASTER_DATA_KEY_SUCCESSFULL,
        data
    }
}
export const uploadBulkMasterDataKeyFail = (data) => {
    return {
        type: UPLOAD_BULK_MASTER_DATA_KEY_FAILURE,
        data
    }
}